var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1890ff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.5H3C1.6,5.5,0.5,4.4,0.5,3v0c0-1.4,1.1-2.5,2.5-2.5h3V5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 6,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,5.5H0v-5h3c1.4,0,2.5,1.1,2.5,2.5v0C5.5,4.4,4.4,5.5,3,5.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0,7c0,3.9,3.1,7,7,7h0c3.9,0,7-3.1,7-7v0c0-3.9-3.1-7-7-7H0z M7,12L7,12c-2.8,0-5-2.2-5-5V2h5c2.8,0,5,2.2,5,5v0 C12,9.8,9.8,12,7,12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12) rotate(90 7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0,7c0,3.9,3.1,7,7,7h0c3.9,0,7-3.1,7-7v0c0-3.9-3.1-7-7-7H0z M7,12L7,12c-2.8,0-5-2.2-5-5V2h5c2.8,0,5,2.2,5,5v0 C12,9.8,9.8,12,7,12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,384)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12) rotate(-90 7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0l0,7c0,3.9,3.1,7,7,7h0c3.9,0,7-3.1,7-7v0c0-3.9-3.1-7-7-7H0z M7,12L7,12c-2.8,0-5-2.2-5-5V2h5c2.8,0,5,2.2,5,5v0 C12,9.8,9.8,12,7,12z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,432)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.591ff19b7c09af703bc53e801c0d14c9.svg";
export { ForwardRef as ReactComponent };